import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { List, EditPen, Timer } from "@element-plus/icons-vue";
import MenuBox from "@/components/exam/MenuBox.vue";
import mm from "@/components/examItem/item-mm.vue";
import mm_drag from "@/components/examItem/item-mm-drag.vue";
import mm_mcq from "@/components/examItem/item-mm-mcq.vue";
import writing from "@/components/examItem/item-writing.vue";
import proofreading from "@/components/examItem/item-proofreading.vue";
import SelfEvaluation from "@/components/exam/SelfEvaluation.vue";
import { useRoute } from "vue-router";
import { reactive, ref, onBeforeUnmount, watch } from "vue";
import { GetResumeApi, SubmitExamApi, SetResumeApi } from "@/api/examApi.js";
import { ElLoading, ElMessage, ElMessageBox } from "element-plus";
let examId = "";
let route;
export default {
  components: {
    MenuBox,
    mm,
    mm_drag,
    mm_mcq,
    writing,
    proofreading,
    SelfEvaluation
  },
  props: ["examInfo", "netState"],
  setup(props, content) {
    let paperInfo = reactive({});
    let itemNo = ref(0);
    let cache = reactive({});
    let totalQuestion = ref(0);
    let step = ref(0);
    route = useRoute();
    examId = props.examInfo.examId + "";
    //试卷
    let {
      getPaper
    } = usePaper(paperInfo, totalQuestion, props.examInfo);
    //缓存
    let {
      getResume,
      setAnswer,
      setcache
    } = useAnswer(cache, getPaper, props.examInfo, itemNo, step, props.netState, content);
    //流程
    let {
      timeText,
      setCountDown,
      finishExam
    } = useExamProcess(props.examInfo, content, cache, setcache, totalQuestion, step);
    //步骤控制
    function changeStep() {
      step.value++;
      //（开始倒计时）
      if (step.value == 1) {
        setCountDown();
      }
      //考试结束
      else if (step.value == 5) {
        content.emit("finishExam");
      }
    }
    getResume(setCountDown);
    watch(props.netState, () => {
      setCountDown();
    });
    return {
      Timer,
      timeText,
      finishExam,
      changeStep,
      step,
      itemNo,
      paperInfo,
      cache,
      setAnswer,
      setcache,
      getPaper,
      List,
      EditPen
    };
  }
};
//获取试卷
function usePaper(paperInfo, totalQuestion, examInfo) {
  //获取试卷
  function getPaper(id, setCountDown) {
    Object.assign(paperInfo, examInfo.papers[id] || examInfo.papers[0]);
    totalQuestion.value = useSettingPaper(paperInfo, examInfo.subdivide);
    //倒计时
    if (setCountDown) setCountDown();
  }
  return {
    getPaper
  };
}
//目录
function useSettingPaper(paperInfo, subdivide) {
  let task = 1;
  let taskNo = 0;
  if (subdivide == 3) {
    if (window.localStorage.getItem("preTotalNo-" + (route.query.examid || route.query.examId))) {
      task += Number(window.localStorage.getItem("preTotalNo-" + (route.query.examid || route.query.examId)));
    }
  }
  paperInfo.items.forEach(items => {
    items.menu = task;
    items.questionGroupList.forEach(group => {
      group.questionList.forEach(questionItem => {
        if (questionItem.questionScore) {
          task++;
          taskNo++;
        }
      });
    });
    //mm的分类
    if (items.questionGroupList[0].questionMethod == "mm") {
      //选择题展示
      if (items.questionGroupList[0].questionList[0].questionStem.split(" ").length > 2) {
        items.questionGroupList[0].questionMethod = "mm-mcq";
      } else if (items.questionGroupList[0].choiceList[0].choiceText.split(" ").length > 1) {
        items.questionGroupList[0].questionMethod = "mm-drag";
      }
    }
  });
  return taskNo;
}
//缓存 答案
function useAnswer(cache, getPaper, examInfo, itemNo, step, netState, content) {
  let setCacheTime = null;
  //获取缓存
  function getResume(setCountDown) {
    const loading = ElLoading.service({
      lock: true,
      text: "获取作答数据..",
      background: "rgba(0, 0, 0, 0.7)"
    });
    GetResumeApi(examId).then(r => {
      loading.close();
      if (r.status < 400) {
        Object.assign(cache, r.data);
        //题号
        if (cache.interruptMark) {
          cache.interruptMark = JSON.parse(cache.interruptMark);
          itemNo.value = cache.interruptMark.itemNo || 0;
          step.value = cache.interruptMark.step || 0;
        } else if (examInfo.examType == 3) {
          cache.interruptMark = {};
          //跳过自评
          if (examInfo.papers.length == 1) {
            examInfo.papers[0].paperType == 7 ? step.value = 1 : step.value = 2;
            examInfo.subdivide = 3;
          } else {
            step.value = 1;
            examInfo.subdivide = 2;
          }
        } else {
          cache.interruptMark = {};
          if (examInfo.subdivide == 3) {
            step.value = 2;
          } else {
            step.value = 0;
          }
        }
        //步骤
        if (step.value == 0) {
          getPaper(0);
        } else {
          if (examInfo.examType == 3) {
            if (step.value == 1) {
              getPaper(0, setCountDown);
            } else {
              getPaper(1, setCountDown);
            }
          } else {
            getPaper(0, setCountDown);
          }
        }
      } else {
        ElMessage({
          type: "error",
          showClose: true,
          message: r.msg
        });
      }
    });
  }
  //设置答案
  function setAnswer(msg) {
    for (let key in msg) {
      cache.answers[key] = msg[key];
    }
  }
  //设置缓存
  function setcache(clear) {
    if (setCacheTime == cache.remaining) {
      return 0;
    } else {
      setCacheTime = cache.remaining;
    }
    let data = {
      answers: {
        ...cache.answers
      },
      audios: {
        ...cache.audios
      },
      remaining: cache.remaining,
      examId: examId,
      //题号
      interruptMark: {
        itemNo: clear ? 0 : itemNo.value,
        step: step.value,
        moreTime: cache.interruptMark.moreTime
      }
    };
    if (netState) {
      window.localStorage.removeItem("cache-" + examId);
      SetResumeApi(data).then(r => {
        // if (r.status == 404) {
        //   ElMessage({
        //     type: "error",
        //     showClose: true,
        //     message: "您的考试已被强制提交。",
        //   });
        //   content.emit("finishExam");
        // } else
        if (r.status == 406) {
          ElMessage({
            type: "error",
            showClose: true,
            message: "您的考试已被重置。"
          });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else if (r.status == 403) {
          ElMessage({
            type: "error",
            showClose: true,
            message: "您的登录已失效或在别处登录"
          });
          setTimeout(() => {
            window.closed();
          }, 2000);
        } else if (clear) {
          examInfo.subdivide = 3;
          content.emit("finishExam", {
            ...examInfo
          });
        }
      });
    } else {
      data.interruptMark ? data.interruptMark = JSON.stringify(data.interruptMark) : "";
      window.localStorage.setItem("cache-" + examId, JSON.stringify(data));
    }
  }
  return {
    setAnswer,
    setcache,
    getResume
  };
}
//流程控制(倒计时，交卷)
function useExamProcess(examInfo, content, cache, setcache, totalQuestion, step) {
  let countDownTimer;
  let moreTimer;
  let countTimer;
  let timeText = ref("00:00:00");
  onBeforeUnmount(() => {
    if (countDownTimer) countDownTimer.close();
    countDownTimer = null;
    if (countTimer) clearInterval(countTimer);
  });
  //启动倒计时
  function setCountDown() {
    let time = cache.remaining || examInfo.remainingTime;
    countDownTimer = new WebSocket("wss://unilearn.fltrp.com/jzws/count-down");
    countDownTimer.onopen = () => {
      countDownTimer.send(time + ":1:" + examInfo.userId);
    };
    countDownTimer.onmessage = evt => {
      time = evt.data;
      if (time <= 0) {
        if (examInfo.subdivide == 2) {
          finishExam(4);
        } else {
          finishExam(2);
          // setmoreCountDown();
        }
      } else {
        let s = time % 60;
        let m = parseInt(time / 60) % 60;
        let h = parseInt(parseInt(time / 60) / 60);
        timeText.value = `${h > 9 ? h : "0" + h}:${m > 9 ? m : "0" + m}:${s > 9 ? s : "0" + s}`;
        cache.remaining = time;
        //自动缓存(30s)
        if (time % 30 == 0) {
          setcache();
        }
        //倒计时提示
        if (time == 300 && examInfo.subdivide == 3) {
          ElMessage({
            type: "warning",
            showClose: true,
            message: "距离考试结束仅有5分钟"
          });
        }
      }
    };
    countDownTimer.onclose = e => {
      if (!e.wasClean && window.navigator.onLine && countDownTimer && countDownTimer.readyState != 0) {
        countDownTimer.close();
        setCountDown();
      }
    };
  }
  // function setCountDown() {
  //   let time = cache.remaining || examInfo.remainingTime;
  //   countTimer = setInterval(() => {
  //     time--;
  //     if (time <= 0) {
  //       if (examInfo.subdivide == 2) {
  //         finishExam(4);
  //       } else {
  //         finishExam(2);
  //         // setmoreCountDown();
  //       }
  //     } else {
  //       let s = time % 60;
  //       let m = parseInt(time / 60) % 60;
  //       let h = parseInt(parseInt(time / 60) / 60);
  //       timeText.value = `${h > 9 ? h : "0" + h}:${m > 9 ? m : "0" + m}:${
  //         s > 9 ? s : "0" + s
  //       }`;
  //       cache.remaining = time;
  //       //自动缓存(30s)
  //       if (time % 30 == 0) {
  //         setcache();
  //       }
  //       //倒计时提示
  //       if (time == 300 && examInfo.subdivide == 3) {
  //         ElMessage({
  //           type: "warning",
  //           showClose: true,
  //           message: "距离考试结束仅有5分钟",
  //         });
  //       }
  //     }
  //   }, 1000);
  // }
  //倒计时验证

  function setmoreCountDown() {
    if (countDownTimer) countDownTimer.close();
    clearInterval(moreTimer);
    if (examInfo.subdivide == 3) {
      let moreTime = cache.interruptMark.moreTime || 300;
      ElMessageBox.confirm(`申请延时五分钟?`, "", {
        showClose: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        moreTimer = setInterval(() => {
          if (moreTime <= 0) {
            clearInterval(moreTimer);
            //交卷
            finishExam(2);
          } else {
            moreTime--;
            let min = parseInt(moreTime / 60);
            let sec = moreTime % 60;
            timeText.value = min > 9 ? min : "0" + min;
            timeText.value += ":";
            timeText.value += sec > 9 ? sec : "0" + sec;
            cache.interruptMark.moreTime = moreTime;
            cache.remaining = moreTime;
          }
        }, 1000);
      }).catch(() => {
        //交卷
        finishExam(2);
      });
    } else {
      finishExam(4);
    }
  }
  //交卷(1手动交卷 2倒计时结束被交卷 3提交分卷 4间接写作倒计时结束)
  function finishExam(type) {
    if (type == 1) {
      //前置判断
      if (examInfo.totalTime - cache.remaining < 300) {
        ElMessageBox.confirm(`该部分作答五分钟后才可以提交`, "", {
          showClose: false,
          showCancelButton: false,
          cancelButtonText: false,
          type: "warning"
        });
        return 0;
      }
      //计算题目
      ElMessageBox.confirm(`确认交卷吗？`, "", {
        showClose: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        finishExamApi(1);
      });
    } else if (type == 2) {
      finishExamApi(2);
    } else if (type == 3) {
      let questCount = 0;
      for (let key in cache.answers) {
        if (cache.answers[key] || cache.answers[key] === 0) {
          questCount++;
        }
      }
      ElMessageBox.confirm(`本部分提交后不能返回修改${totalQuestion.value - questCount > 0 ? `（还有题${totalQuestion.value - questCount}未作答)` : ""}，确认提交吗？`, "", {
        showClose: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        finishExamApi(1, 1);
      });
    } else if (type == 4) {
      finishExamApi(1, 1);
    }
  }
  function finishExamApi(submit, syncScore) {
    if (countDownTimer) countDownTimer.close();
    countDownTimer = null;
    if (countTimer) clearInterval(countTimer);
    clearInterval(moreTimer);
    let data = {
      answers: {
        ...cache.answers
      },
      audios: {
        ...cache.audios
      },
      remaining: cache.remaining,
      examId: examId,
      submit: submit,
      syncScore: syncScore ? syncScore : 0
    };
    const loading = ElLoading.service({
      lock: true,
      text: "正在提交考试..",
      background: "rgba(0, 0, 0, 0.7)"
    });
    if (examInfo.examType == 3 && (submit == 3 || submit == 1)) {
      if (examInfo.papers.length == 1 || examInfo.subdivide == 3) {
        step.value = 2;
      } else {
        step.value++;
        setcache(true);
        return 0;
      }
    }
    SubmitExamApi({
      ...data
    }).then(r => {
      if (r.status < 400) {
        ElMessage({
          type: "success",
          showClose: true,
          message: "提交成功"
        });
        setTimeout(() => {
          loading.close();

          //进入考后自评
          if (step.value == 2) {
            if (examInfo.examType == 3) {
              content.emit("finishExam");
            } else {
              step.value++;
            }
          } else {
            if (submit == 1) {
              content.emit("finishExam", r.data);
            } else {
              content.emit("finishExam");
            }
          }
        }, 1000);
      } else {
        loading.close();
        ElMessage({
          type: "error",
          showClose: true,
          message: r.msg
        });
      }
    });
  }
  return {
    timeText,
    setCountDown,
    finishExam,
    setmoreCountDown
  };
}